import { z } from "zod";
import { MetricKeyEnum } from "../metrics";

// Schema
export const optimizationRequestSchema = z.object({
  answers: z.record(z.string()).optional().default({}),
  focusedMetrics: z
    .array(z.nativeEnum(MetricKeyEnum))
    .optional()
    .describe(
      "Specific metrics to focus optimization on. If not provided, all metrics will be considered",
    ),
});

// Type
export type OptimizationRequest = z.infer<typeof optimizationRequestSchema>; 